define.alias("shared/components/shared/wizard/slide", "media/components/shared/wizard/slide");